"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RequiredSign = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const RequiredSign = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "subtitle1",
        component: "span",
        color: "error.light",
        "data-testid": getTestId(_constants.FORM_REQUIRED_SIGN_FIELD),
        children: "*"
    });
};
exports.RequiredSign = RequiredSign;
